﻿import LfWebService from '../Services/LfWebService';

// actions used on all pages

export function pageHasErroredAction(bool) {
    return {
        type: 'PAGE_HAS_ERRORED',
        hasErrored: bool
    };
}

export function pageErrorAction(error) {
    return {
        type: 'PAGE_ERROR',
        error
    };
}

export function pageIsLoadingAction(bool) {
    return {
        type: 'PAGE_IS_LOADING',
        isLoading: bool
    };
}

export function pageCurrentStepAction(step) {
    return {
        type: 'PAGE_CURRENT_STEP',
        step
    };
}

export function getPreregistrationsUrlAction() {
    const lfWebService = new LfWebService(); 
    return (dispatch, getState) => {
        return lfWebService.insurancePreregistrationsUrl();
    };
}

export function getHealthDeclarationUrlForAction(insuranceName, objId = null) {
    const lfWebService = new LfWebService();
    return (dispatch, getState) => {
        return lfWebService.healthDeclarationUrl(insuranceName, objId);
    };
}

export function redirectToHealthDeclarationForAction(insuranceName, objId = null) {
    const lfWebService = new LfWebService();
    return (dispatch, getState) => {
        window.location.href = lfWebService.healthDeclarationUrl(insuranceName, objId);
    };
}

export function getInsurancePurchaseUrlForAction(insuranceGroupNames, preSelection, possessionId) {
    const lfWebService = new LfWebService();

    return (dispatch, getState) => {
        return lfWebService.insurancePurchaseUrl(insuranceGroupNames, preSelection, possessionId);
    };
}